import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AppComponent } from './app.component';
import { HomeComponent } from './home/home.component';
import { LocatorMainComponent } from './locator/locator-main.component';
import { TransactionStatusComponent } from './transaction-status/transaction-status.component';
import { SignInComponent } from './feature/sign-in/sign-in.component';

export const routes: Routes = [
  {
    path: 'transaction-status',
    component: TransactionStatusComponent,
  },
  {
    path: '',
    component: HomeComponent,
    pathMatch: 'full',
  },
  {
    path: 'signin',
    component: SignInComponent,
  },
  {
    path: 'locations',
    component: LocatorMainComponent,
    pathMatch: 'full',
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
